import React, { ReactElement } from 'react'
import moment from 'moment'
import { Tag as AntTag } from 'antd'
import { capitalize, lowerCase } from 'lodash-es'
import { TIME_FORMAT } from 'core/constants'
import { statusesCertificateColorMap } from 'core/utils/constants'
import { Tag, TagType } from '@digicert/dcone-common-ui'
import { Translate } from 'react-localize-redux'
import { getUserStatus } from '../../secure-pages/users/Users.helpers'

export const dateTimeRender = (date: string): string => moment(date).format(TIME_FORMAT)

export const capitalizeRender = (value: string): string => capitalize(lowerCase(value))

export const certificateStatusesRender = (status: string): ReactElement =>
  <AntTag color={statusesCertificateColorMap[status]}>{capitalize(status)}</AntTag>

export const statusRender = (user) => {
  let tagType
  if (user.status) {
    switch (user.status){
      case 'ACTIVE': tagType = TagType.ACTIVE
        break;
      case 'DELETED': tagType = TagType.DANGER
        break;
      case 'LOCKED': tagType = TagType.DANGER
        break;
      case 'PENDING': tagType = TagType.WARNING
        break;
      case 'ALL': tagType = TagType.WARNING
        break;
      case 'DISABLED': tagType = TagType.INACTIVE
        break;
      case 'INACTIVE': tagType = TagType.INACTIVE
        break;
      case 'VALID': tagType = TagType.ACTIVE
        break;
    }
  } else {
    switch (user){
      case 'ACTIVE': tagType = TagType.ACTIVE
        break;
      case 'DELETED': tagType = TagType.DANGER
        break;
      case 'LOCKED': tagType = TagType.DANGER
        break;
      case 'PENDING': tagType = TagType.WARNING
        break;
      case 'ALL': tagType = TagType.WARNING
        break;
      case 'DISABLED': tagType = TagType.INACTIVE
        break;
      case 'INACTIVE': tagType = TagType.INACTIVE
        break;
      case 'VALID': tagType = TagType.ACTIVE
        break;
    }
  }

  return (
    <Tag type={tagType}>
      <Translate id={`common.statuses.${getUserStatus(user)}`} />
    </Tag>
  )
}

export const statusPillRenderer = (status) => {
  let tagType
    switch (status.toUpperCase()){
      case 'ACTIVE': tagType = TagType.ACTIVE
        break;
      case 'DELETED': tagType = TagType.DANGER
        break;
      case 'LOCKED': tagType = TagType.DANGER
        break;
      case 'PENDING': tagType = TagType.WARNING
        break;
      case 'ALL': tagType = TagType.WARNING
        break;
      case 'DISABLED': tagType = TagType.INACTIVE
        break;
      case 'INACTIVE': tagType = TagType.INACTIVE
        break;
      case 'VALID': tagType = TagType.ACTIVE
        break;
    }

  return (
    <Tag type={tagType}>
      <Translate id={`common.statuses.${status}`} />
    </Tag>
  )
}
